import { oAuthCodeGQLQuery, oAuthTokenGQLQuery } from '../../graphql/index.js';
export class OAuthClient {
    constructor(client) {
        this.client = client;
    }
    async getOAuthCode(variables) {
        const result = await this.client.authorizedRequest({
            query: oAuthCodeGQLQuery(),
            variables,
        });
        return result.oAuthCode;
    }
    async getOAuthToken(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: oAuthTokenGQLQuery(),
            variables,
            customToken: accessToken,
            // as we are trying to authenticate the app, we need to force to check basic token
            useBasicToken: true,
        });
        return result.oAuthTokens;
    }
}
